<app-admin-header
  *ngIf="!isInnerComponent"
  [header]="courseData?.title"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>

<div *ngIf="isInnerComponent" class="d-flex flex-wrap justify-content-between">
  <div>
    <h3>{{ courseData?.title }}</h3>
  </div>
  <div>
    <button (click)="goBack()" class="main-btn">
      <i class="pi pi-fw pi-angle-right m-r-0-7"></i>{{ "Back" | translator }}
    </button>
  </div>
</div>

<app-skelitions [value]="6" [hidden]="!skelition"></app-skelitions>
<app-no-data *ngIf="!skelition && !courseData"></app-no-data>

<div
  class="{{
    isInnerComponent
      ? 'container-fluid v4-bg-img-2'
      : 'container-fluid v4-bg-img'
  }}"
  *ngIf="courseData && !skelition"
>
  <!-- course / Tr... update end here -->

  <div class="custom-nav">
    <div class="pos-rel">
      <div class="row w-100 d-flex align-items-center justify-content-center">
        <div class="col-md-2 col-12 p-0">
          <div class="d-flex align-items-center">
            <div>
              <i
                (click)="goBack()"
                class="pi pi-fw pi-angle-right back-icon"
              ></i>
            </div>
            <div class="flex-column">
              <!-- <div>
                <h6 class="user-name m-0">{{ courseData.title }}</h6>
              </div> -->
              <div>
                <h6 class="user-name m-0">
                  {{ courseData.end_date | date }} -
                  {{ courseData.start_date | date }}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-10 col-12">
          <div class="p-l-2-5rem">
            <span
              class="data-desc"
              [innerHTML]="courseData.description | safeHTML"
            ></span>
          </div>
        </div>
      </div>
      <div
        *ngIf="!viewOnly"
        class="d-flex flex-wrap align-items-center upper-edit-pos-abs"
      >
        <i
          (click)="openTrainingUpdateModal()"
          class="fa-solid fa-edit edit-icon-2 pointer"
        ></i>
      </div>
    </div>
  </div>

  <div class="custom-nav-2">
    <div class="d-flex flex-wrap justify-content-between align-items-center">
      <div class="d-flex">
        <div class="d-flex flex-wrap">
          <!-- (click)="changeCurrentDataTab(trainingDataTabs.Session)" -->
          <span
            *ngIf="sessions.length > 0"
            class="train-tabs"
            [ngClass]="{
              'train-tabs-active': currentDataTab == trainingDataTabs.Session
            }"
          >
            {{ "Training timeline" | translator }}</span
          >
          <!-- <span *ngIf="assessments.length > 0" (click)="changeCurrentDataTab(trainingDataTabs.Assessment)"
            class="train-tabs" [ngClass]="{
              'train-tabs-active': currentDataTab == trainingDataTabs.Assessment
            }">{{ "the exams" | translator }}</span>
          <span *ngIf="surveys.length > 0" (click)="changeCurrentDataTab(trainingDataTabs.Survey)" class="train-tabs"
            [ngClass]="{
              'train-tabs-active': currentDataTab == trainingDataTabs.Survey
            }">{{ "Surveys" | translator }}</span>
          <span *ngIf="sources.length > 0" (click)="changeCurrentDataTab(trainingDataTabs.Source)" class="train-tabs"
            [ngClass]="{
              'train-tabs-active': currentDataTab == trainingDataTabs.Source
            }">{{ "Sources" | translator }}
          </span> -->
          <!-- <span *ngIf="
              courseMaterial.length > 0 && (!viewOnly || checkUserEnrollment())
            " (click)="changeCurrentDataTab(trainingDataTabs.CourseMaterial)" class="train-tabs" [ngClass]="{
              'train-tabs-active':
                currentDataTab == trainingDataTabs.CourseMaterial
            }">{{ "Material" | translator }}</span> -->
          <!-- <span *ngIf="attendances.length > 0 && (!viewOnly || canViewAttendanceMarkAttendance)"
            (click)="changeCurrentDataTab(trainingDataTabs.Attendance)" class="train-tabs" [ngClass]="{
              'train-tabs-active': currentDataTab == trainingDataTabs.Attendance
            }">{{ "Attendance" | translator }}</span> -->
        </div>
      </div>
      <div class="d-flex flex-wrap" *ngIf="!viewOnly">
        <button
          (click)="addSessionModal = true; isCertAdd = false"
          *ngIf="
            checkAdditionPermission(additionTabs.Session) && allowSessionAdd
          "
          class="main-btn"
        >
          <i class="pi pi-plus-circle m-r-0-7"></i
          >{{ "Training sessions" | translator }}
        </button>

        <button
          (click)="addSessionModal = true; isCertAdd = true"
          *ngIf="
            checkAdditionPermission(additionTabs.Session) && allowSessionAdd
          "
          class="main-btn"
        >
          <i class="pi pi-plus-circle m-r-0-7"></i
          >{{ "Add Certificate" | translator }}
        </button>

        <button
          *ngIf="checkAdditionPermission(additionTabs.Survey)"
          (click)="addSurveyModal = true"
          class="main-btn"
        >
          <i class="pi pi-plus-circle m-r-0-7"></i>{{ "Surveys" | translator }}
        </button>

        <button
          *ngIf="checkAdditionPermission(additionTabs.Assessment)"
          (click)="addAssessmentModal = true"
          class="main-btn"
        >
          <i class="pi pi-plus-circle m-r-0-7"></i
          >{{ "the exams" | translator }}
        </button>
        <button
          *ngIf="checkAdditionPermission(additionTabs.Source)"
          (click)="addSourcesModal = true"
          class="main-btn"
        >
          <i class="pi pi-plus-circle m-r-0-7"></i>{{ "Sources" | translator }}
        </button>

        <button (click)="addCourseMaterial = true" class="main-btn">
          <i class="pi pi-plus-circle m-r-0-7"></i>{{ "Material" | translator }}
        </button>
        <button
          (click)="openRatingSettingModal()"
          *ngIf="showRatingSettings"
          class="main-btn"
        >
          <i class="pi pi-star m-r-0-7"></i
          >{{ "Rating Surveys Settings" | translator }}
        </button>
        <button
        (click)="reminderModal = true"
        *ngIf="allowImpactSettings"
        class="main-btn"
      >
        <i class="pi pi-star m-r-0-7"></i>{{ "Set Reminder" | translator }}
      </button>
        <button
          (click)="openImpactSettingModal()"
          *ngIf="allowImpactSettings"
          class="main-btn"
        >
          <i class="pi pi-star m-r-0-7"></i>{{ "Impact Settings" | translator }}
        </button>
      </div>
      <div class="d-flex flex-wrap">
        <button
          (click)="openRatingData()"
          *ngIf="allowRatingTrainers && canRateTrainer()"
          class="main-btn"
        >
          <i class="pi pi-star-fill m-r-0-7"></i
          >{{ "Rating Surveys" | translator }}
        </button>
        <!-- <button [routerLink]="'/training/training-results/' + courseId" [queryParams]="{ _id: courseId, from: from }" class="main-btn">
          <i class="pi pi-star-fill m-r-0-7"></i>{{ "Training Results" | translator }}
        </button> -->
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-3 col-12 p-0">
      <!-- Right side tab select section start  -->
      <div class="side-scroll">
        <div
          [ngClass]="{ 'selected-session': currentSession == session }"
          (click)="changeSession(session)"
          *ngFor="let session of getViewContent(); let i = index"
        >
          <div *ngIf="!viewOnly" class="pos-rel">
            <button
              (click)="onSessionDeleteClick(session)"
              class="cross pointer"
            >
              <i class="fa fa-times"></i>
            </button>
            <button
              *ngIf="
                session.sessionType == 'Onsite' ||
                session.sessionType == 'Online'
              "
              (click)="openRecreateModal(session)"
              class="cross-2 pointer"
            >
              <i class="pi pi-copy"></i>
            </button>
          </div>
          <div
            class="flex-column side-nav-ui {{
              !canPlaySession(session) ? 'locked' : 'unlocked'
            }}"
          >
            <span *ngIf="!canPlaySession(session)" class="pi pi-lock"></span>
            <div>
              <ng-container *ngIf="session.sessionType == 'Assessment'">
                <h6 class="user-name-side-nav">
                  {{
                    session.assessment ? session.assessment.name : session.title
                  }}
                </h6>
              </ng-container>
              <ng-container *ngIf="session.sessionType == 'Survey'">
                <h6 class="user-name-side-nav">
                  {{ session.survey ? session.survey.name : session.title }}
                </h6>
              </ng-container>
              <ng-container
                *ngIf="
                  session.sessionType !== 'Survey' &&
                  session.sessionType !== 'Assessment'
                "
              >
                <h6 class="user-name-side-nav">{{ session.title }}</h6>
              </ng-container>
            </div>
            <div
              *ngIf="currentDataTab != trainingDataTabs.CourseMaterial"
              class="d-flex justify-content-between p-l-1-rem"
            >
              <span
                class="date-time {{
                  session.sessionType != 'Survey' &&
                  session.sessionType != 'Assessment'
                    ? ''
                    : 'hide'
                }}"
                >{{ session.date | date }}</span
              >
              <span class="date-time">{{
                session.end_time && session.start_time
                  ? getFormattedTime(session.end_time) +
                    "-" +
                    getFormattedTime(session.start_time)
                  : ""
              }}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div
                class="mt-1 d-flex justify-content-between align-items-center"
              >
                <div
                  *ngIf="
                    (currentDataTab == trainingDataTabs.CourseMaterial ||
                      currentDataTab == trainingDataTabs.Session) &&
                    !viewOnly
                  "
                >
                  <button
                    class="create-training-btn mx-1"
                    (click)="
                      $event.stopPropagation(); changeOrder(session, i, false)
                    "
                  >
                    <i class="fa-solid fa-arrow-up"></i>
                  </button>
                  <button
                    class="create-training-btn mx-1"
                    (click)="
                      $event.stopPropagation(); changeOrder(session, i, true)
                    "
                  >
                    <i class="fa-solid fa-arrow-down"></i>
                  </button>
                </div>
                <div
                  *ngIf="currentDataTab == trainingDataTabs.CourseMaterial"
                  class="capsoul-col-4 text-start"
                >
                  <a
                    [href]="session.url"
                    target="_blank"
                    class="my-3 word-break-word color-white-col-4"
                  >
                    <i class="pi pi-download mx-2"></i
                    >{{ "to download" | translator }}</a
                  >
                </div>
              </div>
              <!-- only for history tab. -->
              <div
                *ngIf="
                  ((!viewOnly && isOnlineOnsiteSession(session)) ||
                    (isTrainer &&
                      isOnlineOnsiteSession(session) &&
                      canMarkAttendance(session))) &&
                  isCourseStart()
                "
                class="d-flex justify-content-end p-l-1-rem mt-1"
              >
                <button
                  (click)="openAttendanceModal(true)"
                  class="create-training-btn m-rl"
                >
                  {{ "View Attendance" | translator }}
                </button>

                <button
                  (click)="openAttendanceModal(false)"
                  class="create-training-btn"
                >
                  {{ "Mark Attendance" | translator }}
                </button>
              </div>
              <!-- only for course tab. -->
            </div>
          </div>
        </div>

        <!-- Rate Trainers Tab -->
        <div
          *ngIf="viewOnly && canRateUser()"
          [ngClass]="{ 'selected-session': ratingModal }"
          (click)="canCreateCertificate() ? openRatingData() : null"
        >
          <div
            class="flex-column side-nav-ui {{
              !canCreateCertificate() ? 'locked' : 'unlocked'
            }}"
          >
            <span *ngIf="!canCreateCertificate()" class="pi pi-lock"></span>
            <div>
              <h6 class="user-name-side-nav">
                {{ "Rate Trainer" | translator }}
              </h6>
            </div>
            <div
              class="d-flex justify-content-between align-items-center"
              style="display: none"
            >
              <div
                class="mt-1 d-flex justify-content-between align-items-center"
              ></div>
            </div>
          </div>
        </div>

        <!-- Impact Training -->
        <div
          *ngIf="canAttemptImpact()"
          [ngClass]="{ 'selected-session': showTrainerImpact }"
          (click)="openTrainerImpact()"
        >
          <div
            class="flex-column side-nav-ui {{ false ? 'locked' : 'unlocked' }}"
          >
            <span class="fa-solid fa-users-rays"></span>
            <div>
              <h6 class="user-name-side-nav">
                {{ "Impact Measurement" | translator }}
              </h6>
            </div>
            <div
              class="d-flex justify-content-between align-items-center"
              style="display: none"
            >
              <div
                class="mt-1 d-flex justify-content-between align-items-center"
              ></div>
            </div>
          </div>
        </div>

        <!-- Certificate Tab -->
        <div
          [ngClass]="{ 'selected-session': certificateTabSelected }"
          (click)="canCreateCertificate() ? changeSession('Certificate') : null"
        >
          <div
            class="flex-column side-nav-ui {{
              !canCreateCertificate() ? 'locked' : 'unlocked'
            }}"
          >
            <span *ngIf="!canCreateCertificate()" class="pi pi-lock"></span>
            <div>
              <h6 class="user-name-side-nav">
                {{ "Certificate Record" | translator }}
              </h6>
            </div>

            <div
              class="d-flex justify-content-between align-items-center"
              style="display: none"
            >
              <div
                class="mt-1 d-flex justify-content-between align-items-center"
              >
                <!-- <div *ngIf="
                  (currentDataTab == trainingDataTabs.CourseMaterial ||
                    currentDataTab == trainingDataTabs.Session) &&
                  !viewOnly
                ">
                  <button class="create-training-btn mx-1" (click)="
                    $event.stopPropagation(); changeOrder(session, i, false)
                  ">
                    <i class="fa-solid fa-arrow-up"></i>
                  </button>
                  <button class="create-training-btn mx-1" (click)="
                    $event.stopPropagation(); changeOrder(session, i, true)
                  ">
                    <i class="fa-solid fa-arrow-down"></i>
                  </button>
                </div> -->
                <!-- <div *ngIf="currentDataTab == trainingDataTabs.CourseMaterial" class="capsoul-col-4 text-start">
                  <a [href]="session.url" target="_blank" class="my-3 word-break-word color-white-col-4">
                    <i class="pi pi-download mx-2"></i>{{ "to download" | translator }}</a>
                </div> -->
              </div>
              <!-- only for history tab. -->
              <!-- <div class="d-flex justify-content-end p-l-1-rem mt-1" style="display: none;opacity: 0;">
                <button (click)="openAttendanceModal(true)" class="create-training-btn m-rl">
                  {{ "View Attendance" | translator }}
                </button>

                <button (click)="openAttendanceModal(false)" class="create-training-btn">
                  {{ "Mark Attendance" | translator }}
                </button>
              </div> -->
              <!-- only for course tab. -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right side tab select section end -->

    <div class="col-md-9 col-12">
      <div class="container-fluid px-1 my-4 pos-rel">
        <!-- Left side card section start  -->
        <div class="margin-center">
          <!-- edit  -->
          <section
            *ngIf="
              (!viewOnly &&
                currentDataTab != trainingDataTabs.CourseMaterial) ||
              checkTrainerEditPermission(currentSession)
            "
          >
            <div *ngIf="!!currentSession" class="d-flex justify-content-end">
              <span>
                <i
                  class="fa-solid fa-edit edit-pos-abs pointer"
                  (click)="editSession()"
                ></i>
              </span>
            </div>
          </section>
        </div>
      </div>

      <app-main-view
        *ngIf="!!currentSession && isCertAdd == false && !showImpactSettings"
        [viewOnly]="viewOnly"
        (sessionUpdated)="sessionUpdated($event)"
        [courseId]="courseId"
        [viewData]="currentSession"
      ></app-main-view>

      <div *ngIf="showImpactSettings">
        <div
          class="d-flex column gap-1 align-items-start justify-content-start mb-4"
        >
          <span class="ans-color">{{ "Select Trainers" | translator }}</span>
          <div class="pppp-drop">
            <p-dropdown
              [options]="courseTrainers"
              placeholder="{{ 'Select Trainers' | translator }}"
              [(ngModel)]="impactTrainers"
              optionLabel="name"
              optionValue="user_id"
              appendTo="body"
            >
            </p-dropdown>
          </div>
        </div>
        <app-training-survey
          *ngIf="!!courseData"
          [courseData]="courseData"
          (mainSurveyUpdated)="mainSurveyUpdated()"
          [updateSurveyData]="updateSurveyData"
          [addNewSurvey]="false"
          [courseId]="courseId"
          [trainingTypeId]="trainingType._id"
          (sessionCreated)="(null)"
          (sessionSelected)="setSelectedSurveyImpact($event)"
          [fromRating]="true"
          [fromImpact]="true"
          [ratingType]="'Trainer'"
          [selectedSurveyID]="selectedSurveyImpactID"
        ></app-training-survey>
        <h2 class="my-2">{{ "Select Attendees" | translator }}</h2>

        <div
          class="d-flex flex-column align-items-start mt-3 w-100 mb-3"
          *ngIf="!fetchingMangers"
        >
          <label>{{ "Select Percentage to show above" | translator }}</label>
          <div class="d-flex flex-row gap-2 align-items-end w-100">
            <p-dropdown
              [optionValue]="'value'"
              [(ngModel)]="fromPercentage"
              [optionLabel]="'label'"
              [options]="attendancePercentageFilterValues"
              placeholder="{{ 'From' | translator }}"
            ></p-dropdown>

            <p-dropdown
              [optionValue]="'value'"
              [(ngModel)]="toPercentage"
              [optionLabel]="'label'"
              [options]="attendancePercentageFilterValues"
              placeholder="{{ 'To' | translator }}"
            ></p-dropdown>

            <p-button
              [disabled]="
                (!fromPercentage || fromPercentage == 0) &&
                (!toPercentage || toPercentage == 0)
              "
              [label]="'Submit' | translator"
              (onClick)="filterByAttendancePercentage()"
            ></p-button>
            <p-button
              [label]="'Reset' | translator"
              (onClick)="resetFilter()"
            ></p-button>
          </div>
        </div>

        <p-table
          [paginator]="true"
          [totalRecords]="filteredAttendees.length"
          [paginator]="false"
          [scrollable]="true"
          [selectionPageOnly]="true"
          *ngIf="filteredAttendees.length > 0 && !fetchingMangers"
          [value]="filteredAttendees"
          dataKey="_id"
          [tableStyle]="{ 'min-width': '50rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <!-- <th>
                <div class="d-flex gap-2">
                  <p-checkbox type="checkbox" name="select-all" [binary]="true" [(ngModel)]="selectAllUsersFlag"
                    (ngModelChange)="toggleSelectAll()" />
                  <label for="selectAllCheckbox" class="p-20" style="cursor: pointer">
                    {{ "Select All" | translator}}
                  </label>
                </div>
              </th> -->
              <th></th>
              <th *ngFor="let column of ['the name', 'E-mail']">
                {{ column | translator }}
              </th>
              <th>{{ "Managers" | translator }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr>
              <td>
                <p-checkbox
                  (ngModelChange)="getUserManagers(user)"
                  type="checkbox"
                  [binary]="true"
                  [(ngModel)]="user.selected"
                >
                </p-checkbox>
              </td>
              <td>
                {{
                  user?.name?.first +
                    " " +
                    user?.name?.middle +
                    " " +
                    user?.name?.last
                }}
              </td>
              <td>
                {{ user.email }}
              </td>
              <td *ngIf="user.selected && user.managers">
                <p-dropdown
                  [optionValue]="'_id'"
                  [(ngModel)]="user.assignedManager"
                  [optionLabel]="'name'"
                  [options]="user.managers"
                  placeholder="{{ 'Select Manager' | translator }}"
                ></p-dropdown>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div *ngIf="fetchingMangers" class="d-center">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <p-button
          icon="pi pi-check"
          label="{{ 'Save' | translator }}"
          (onClick)="updateImpactSettings()"
        ></p-button>
      </div>

      <app-training-certificate
        *ngIf="certificateTabSelected"
        [editFlag]="!viewOnly"
        [certType]="certType"
        [courseId]="courseId"
        [currentSession]="currentSession"
      ></app-training-certificate>

      <app-training-rating
        *ngIf="currentSession == null && showRatingData && !showTrainerImpact"
        [courseId]="courseId"
        [isUser]="isTrainer || isMasterTrainer ? false : !viewOnly"
        [isMainTrainer]="isMasterTrainer"
      ></app-training-rating>

      <app-trainer-impact-tasks
        [courseId]="courseId"
        *ngIf="currentSession == null && showTrainerImpact"
      ></app-trainer-impact-tasks>
    </div>
  </div>
</div>

<app-footer *ngIf="!isInnerComponent"></app-footer>

<!-- Start course / Tr... update here -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  [(visible)]="openUpdateTrainingModal"
  header="{{ 'Update Training' | translator }}"
  [style]="{ width: '95vw', maxWidth: '1200px' }"
  [draggable]="false"
  [resizable]="false"
>
  <form [formGroup]="updateCourseForm" class="train-ms-grey-box" novalidate>
    <!-- //// edit form //// -->
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="column pt-4 max-500">
          <div class="mob-mt-2-5 flex-column">
            <span class="label-ui"
              >{{ "Course title" | translator }}&nbsp;:&nbsp;</span
            >
            <input
              class="my-2"
              type="text"
              id="title"
              placeholder="title"
              formControlName="title"
              pInputText
            />
            <div class="error">
              <div
                *ngIf="updateCourseForm?.controls?.['title']?.touched && updateCourseForm?.controls?.['title']?.errors?.['required']"
                style="color: red; font-size: 12px"
              >
                {{ "The title is required" | translator }}
              </div>
            </div>
          </div>
          <div class="flex-column">
            <span class="label-ui"
              >{{ "starting date" | translator }}&nbsp;:&nbsp;</span
            >
            <p-calendar
              class="mb-2"
              dateFormat="dd-mm-yy"
              (onSelect)="dateValidate($event, 'start_date')"
              formControlName="start_date"
            >
              <ng-template pTemplate="date" let-date>
                <span
                  [ngStyle]="{
                    textDecoration: disbleDates(date)
                      ? 'line-through'
                      : 'inherit'
                  }"
                  >{{ date.day }}</span
                >
              </ng-template>
            </p-calendar>
            <span
              *ngIf="updateCourseForm?.controls?.['start_date']?.touched && updateCourseForm?.controls?.['start_date']?.errors?.['required']"
              [style.color]="'red'"
            >
              {{ dateValidationMessage["start_date"] | translator }},
              {{ "Start Date is required" | translator }}</span
            >
          </div>

          <div class="flex-column">
            <span class="label-ui"
              >{{ "Expiry date" | translator }}&nbsp;:&nbsp;</span
            >
            <p-calendar
              dateFormat="dd-mm-yy"
              (onSelect)="dateValidate($event, 'end_date')"
              formControlName="end_date"
            >
              <ng-template pTemplate="date" let-date>
                <span
                  [ngStyle]="{
                    textDecoration: disbleDates(date)
                      ? 'line-through'
                      : 'inherit'
                  }"
                  >{{ date.day }}</span
                >
              </ng-template>
            </p-calendar>
            <span
              *ngIf="updateCourseForm?.controls?.['end_date']?.touched && updateCourseForm?.controls?.['end_date']?.errors?.['required']"
              [style.color]="'red'"
            >
              {{ dateValidationMessage["end_date"] | translator }},
              {{ "Expiry Date is required" | translator }}</span
            >
          </div>

          <div
            *ngIf="this.trainingType?.name == 'New Branch'"
            class="flex-column"
          >
            <span class="label-ui"
              >{{ "Select Master Trainer" | translator }}&nbsp;:&nbsp;</span
            >
            <p-dropdown
              styleClass="w-100"
              [options]="
                this.showInternal ? internalTrainers : externalTrainers
              "
              optionLabel="name"
              formControlName="master_trainer"
              appendTo="body"
              [filter]="true"
              filterBy="name"
              [showClear]="false"
              placeholder="{{ 'Choose the coach' | translator }}"
            >
              <ng-template let-trainers pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ trainers.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <div class="row my-2">
              <div class="col">
                <p-toggleButton
                  class="v4-ptog-btn"
                  styleClass="w-100"
                  onLabel="{{ 'External' | translator }}"
                  (onChange)="internalExternalSwitch($event)"
                  offLabel="{{ 'Internal' | translator }}"
                ></p-toggleButton>
              </div>
              <div class="col">
                <button
                  class="w-100 v4-btn-every py-2"
                  (click)="addTrainerModal = true"
                >
                  <i class="pi pi-plus v4-ml-2"></i
                  >{{ "Add trainer" | translator }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="col-12 col-md-12 my-2 w-100">
          <div class="description-box-2">
            <div class="img-bg-width">
              <img
                class="w-100 border-15"
                [src]="GlobalConstants.staticFilesURL + courseData?.image"
                onerror="this.src='../../../../assets/icons/SBC/default-img.jpg'"
              />
            </div>
            <div class="d-flex justify-content-center my-2">
              <p-fileUpload
                class="my-2 v4-upload-btn"
                mode="basic"
                name="file"
                [url]="GlobalConstants.apiURL + 'file/data'"
                [auto]="true"
                [chooseLabel]="'Add image' | translator"
                accept="image/*"
                [maxFileSize]="1000000"
                (onUpload)="courseData.image = $event.originalEvent.body.data"
              ></p-fileUpload>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span class="my-3">
      <h5 class="font-600 color mt-3">
        <i class="pi pi-book ml-2 mr-2 course-icon-ui"></i
        >{{ "Description" | translator }}
      </h5>
      <textarea
        formControlName="description"
        [required]="true"
        rows="7"
        id="description"
        pInputTextarea
        [style]="{ height: '320px', width: '100%', borderRadius: '4px' }"
      >
      </textarea>
      <div
        class="error"
        *ngIf="updateCourseForm?.controls?.['description']?.touched && updateCourseForm?.controls?.['description']?.errors?.['required']"
      >
        <div style="color: red; font-size: 12px">
          {{ "Description required" | translator }}
        </div>
      </div>
    </span>

    <button (click)="updateCourse()" class="main-btn py-2 my-3">
      {{ "UpdateTraining" | translator }}
    </button>
  </form>
</p-dialog>

<!-- card details modal here -->

<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="{{ 'Attendance' | translator }}"
  [(visible)]="addAttendanceModal"
  [modal]="true"
  [style]="{ width: '95vw', maxWidth: '1200px' }"
  [draggable]="false"
  [resizable]="false"
>
  <app-training-users-detail
    *ngIf="addAttendanceModal"
    [sessionAtt]="currentSession"
    (updatedAttendees)="updatedAttendees($event)"
  ></app-training-users-detail>
</p-dialog>
<!-- card details modal here end -->

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<!-- Add Trainer -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="{{ 'Add Trainer' | translator }}"
  [(visible)]="addTrainnerModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1400px' }"
  [maximizable]="true"
>
  <app-add-external-user
    *ngIf="addTrainnerModal"
    (updatedData)="handleAddTrainer($event)"
    [type]="'CREATE'"
    [ExternalType]="'trainer'"
  ></app-add-external-user>
</p-dialog>

<p-dialog
  (onHide)="updateSurveyData = null"
  [blockScroll]="true"
  [draggable]="false"
  [header]="
    (!!updateSurveyData ? 'Update survey' : 'Create Survey') | translator
  "
  [(visible)]="addSurveyModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
  [maximizable]="true"
>
  <ng-container *ngIf="!!trainingType && !!trainingType._id">
    <app-training-survey
      *ngIf="!!courseData"
      [courseData]="courseData"
      (mainSurveyUpdated)="mainSurveyUpdated()"
      [updateSurveyData]="updateSurveyData"
      [addNewSurvey]="false"
      [courseId]="courseId"
      [trainingTypeId]="trainingType._id"
      (sessionCreated)="sessionCreated()"
    ></app-training-survey>
  </ng-container>
</p-dialog>

<p-dialog
  (onHide)="updateAssessmentData = null"
  [blockScroll]="true"
  [draggable]="false"
  [header]="
    (!!updateAssessmentData ? 'Update Assessment' : 'Create Assessment')
      | translator
  "
  [(visible)]="addAssessmentModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
  [maximizable]="true"
>
  <ng-container *ngIf="!!trainingType && !!trainingType._id">
    <app-training-assessment
      *ngIf="!!courseData"
      [courseData]="courseData"
      (mainAssessmentUpdated)="mainAssessmentUpdated()"
      [addNewAssessment]="false"
      [updateAssessmentData]="updateAssessmentData"
      [courseId]="courseId"
      [trainingTypeId]="trainingType._id"
      (sessionCreated)="sessionCreated()"
    ></app-training-assessment>
  </ng-container>
</p-dialog>

<!-- Create Session -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  [header]="
    isCertAdd
      ? ('Add Certificate' | translator)
      : ('Create Session' | translator)
  "
  [(visible)]="addSessionModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
  [maximizable]="true"
>
  <app-session-page
    [branchId]="branchId"
    [companyID]="companyId"
    [trainingType]="trainingType?.name"
    [allowedSessions]="allowedTabsStrings"
    [isCertAdd]="isCertAdd"
    [trainingDate]="getCourseDates()"
    *ngIf="addSessionModal"
    (sessionData)="createSession($event)"
  ></app-session-page>
</p-dialog>
<!-- End Create Session -->

<!-- Edit Session -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  [header]="
    isCertAdd
      ? ('Update Certificate' | translator)
      : ('Update Session' | translator)
  "
  [(visible)]="editSessionModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
  [maximizable]="true"
>
  <app-session-page
    [branchId]="branchId"
    [companyID]="companyId"
    [isHistory]="isHistory"
    [trainingType]="trainingType?.name"
    [trainingDate]="getCourseDates()"
    *ngIf="editSessionModal"
    [sessionFormData]="currentSession"
    [allowedSessions]="allowedTabsStrings"
    [isCertAdd]="isCertAdd"
    (sessionData)="updateSession($event)"
  ></app-session-page>
</p-dialog>
<!-- End Edit Session -->

<!-- Recreate Session -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  [header]="'Recreate' | translator"
  [(visible)]="recreateSessionModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
  [maximizable]="true"
>
  <app-session-page
    [branchId]="branchId"
    [companyID]="companyId"
    [isHistory]="isHistory"
    [trainingType]="trainingType?.name"
    [trainingDate]="getCourseDates()"
    *ngIf="recreateSessionModal"
    [sessionFormData]="currentSession"
    [allowedSessions]="allowedTabsStrings"
    (sessionData)="createSession($event)"
    [recreate]="true"
  ></app-session-page>
</p-dialog>
<!-- End Edit Session -->

<!-- Create Course Material Session -->
<p-dialog
  [blockScroll]="true"
  (onHide)="updateMaterialData = null; resetMaterialForm()"
  [draggable]="false"
  [header]="'Add Material' | translator"
  [(visible)]="addCourseMaterial"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
  [maximizable]="true"
>
  <form class="grey-box" [formGroup]="createMaterialForm">
    <div
      class="d-flex flex-column align-items-start justify-content-start grey-box"
    >
      <label class="label-ui" for="title"
        ><i class="fa-regular fa-address-card ml-2 mr-2 result-icons"></i>
        {{ "A Name" | translator }}&nbsp;:&nbsp;</label
      >
      <input
        type="text"
        id="title"
        placeholder="{{ 'write name here' | translator }}"
        formControlName="title"
        pInputText
        class="w-100 mb-3"
      />
    </div>
    <p-tabView
      (onChange)="changeMaterialSessionType($event)"
      class="v4-tabview"
      [activeIndex]="activeMaterialIndex"
    >
      <p-selectButton
        class="v4-active d-flex justify-content-end"
        [options]="blockOptions"
        formControlName="video_mode"
        optionLabel="name"
        optionValue="value"
      ></p-selectButton>
      <p-tabPanel [header]="'Write Text' | translator">
        <div
          class="d-flex flex-column align-items-start justify-content-start grey-box"
          style="height: 20rem"
        >
          <label class="label-ui" for="text"
            ><i class="fa-solid fa-keyboard ml-2 mr-2 result-icons"></i>
            {{ "Text" | translator }}&nbsp;:&nbsp;</label
          >
          <p-editor
            style="height: 100%"
            placeholder="{{ 'Write Text' | translator }}"
            formControlName="text"
            class="w-100 mb-3"
          />
        </div>
      </p-tabPanel>
      <p-tabPanel [header]="'Add Material' | translator">
        <app-file-upload
          #materialUploadElem
          [label]="'Upload File' | translator"
          (response)="materialUploadResponse($event)"
          [imageType]="trainingMaterialImageType"
        ></app-file-upload>
      </p-tabPanel>
      <p-tabPanel [header]="'Write' | translator">
        <div
          class="d-flex flex-column align-items-start justify-content-start grey-box"
        >
          <label class="label-ui" for="url"
            ><i class="fa-solid fa-link ml-2 mr-2 result-icons"></i>
            {{ "Url" | translator }}&nbsp;:&nbsp;</label
          >
          <input
            type="text"
            id="url"
            placeholder="{{ 'URL Title' | translator }}"
            (change)="getVideoUrl('url')"
            formControlName="url"
            pInputText
            class="w-100 mb-3"
          />
        </div>
      </p-tabPanel>
    </p-tabView>
  </form>
  <app-content-view
    *ngIf="
      !!createMaterialForm.get('url')?.value &&
      createMaterialForm.get('sessionType')?.value == 'Material'
    "
    [source]="createMaterialForm.get('url')?.value"
    [contentType]="getContentType(createMaterialForm.get('url')?.value)"
  ></app-content-view>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-center">
      <button
        *ngIf="!!updateMaterialData"
        class="v4-btn-every py-2"
        [disabled]="!createMaterialForm.valid"
        (click)="updateSession(createMaterialForm.getRawValue())"
      >
        {{ "Update" | translator }}
      </button>
      <button
        *ngIf="!updateMaterialData"
        class="v4-btn-every py-2"
        [disabled]="!createMaterialForm.valid"
        (click)="addMaterial()"
      >
        {{ "Save" | translator }}
      </button>
    </div>
  </ng-template>
</p-dialog>
<!-- End Create Course Material Session -->

<p-toast></p-toast>

<!-- RATTING ADVANCED UI DEVELOPED -->
<p-dialog
  header="{{ 'Rate Trainers' | translator }}"
  [(visible)]="ratingModal"
  [style]="{ width: '95vw', maxWidth: '1700px' }"
>
  <div
    *ngIf="this.userRating == undefined"
    class="d-flex justify-content-center"
  >
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div *ngIf="userRating" class="container">
    <p-table
      [value]="userRating"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="5"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "Name" | translator }}</th>
          <th>{{ "Rating" | translator }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rating>
        <tr>
          <td>{{ rating?.name }}</td>
          <td>
            <p-rating
              class="v4-rate"
              [(ngModel)]="rating.score"
              [cancel]="false"
            ></p-rating>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      label="{{ 'Submit' | translator }}"
      (onClick)="submitRating()"
    ></p-button>
  </ng-template>
</p-dialog>
<!-- RATTING ADVANCED UI DEVELOPED -->

<!-- RATTING ADVANCED UI DEVELOPED -->
<p-dialog
  header="{{ 'Rating Surveys Settings' | translator }}"
  [(visible)]="ratingSettingModal"
  [style]="{ width: '95vw', maxWidth: '1700px' }"
>
  <div class="container">
    <p-tabView
      class="v4-tabview ans-color"
      [activeIndex]="0"
      (onChange)="onTabChange($event)"
    >
      <p-tabPanel [header]="'Trainers Rating' | translator">
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>
        <ng-container *ngIf="ratingType == 'User' && ratingSettingModal">
          <app-training-survey
            *ngIf="!!courseData"
            [courseData]="courseData"
            (mainSurveyUpdated)="mainSurveyUpdated()"
            [updateSurveyData]="updateSurveyData"
            [addNewSurvey]="false"
            [courseId]="courseId"
            [trainingTypeId]="trainingType._id"
            (sessionCreated)="(null)"
            (sessionSelected)="setSelectedSurvey($event)"
            [fromRating]="fromRating"
            [ratingType]="ratingType"
            [selectedSurveyID]="selectedSurveryIDUsers"
          ></app-training-survey>
        </ng-container>
      </p-tabPanel>
      <p-tabPanel [header]="'User Rating' | translator">
        <p-messages [(value)]="messages" [enableService]="false"></p-messages>
        <div
          class="d-flex column gap-1 align-items-start justify-content-start mb-4"
        >
          <span class="ans-color">{{ "Select Trainers" | translator }}</span>
          <div class="pppp-drop">
            <p-multiSelect
              [options]="courseTrainers"
              [placeholder]="'Select Trainers' | translator"
              [(ngModel)]="selectedTrainers"
              optionLabel="name"
              optionValue="user_id"
              appendTo="body"
            >
            </p-multiSelect>
          </div>
        </div>
        <ng-container *ngIf="ratingType == 'Trainer' && ratingSettingModal">
          <app-training-survey
            *ngIf="!!courseData"
            [courseData]="courseData"
            (mainSurveyUpdated)="mainSurveyUpdated()"
            [updateSurveyData]="updateSurveyData"
            [addNewSurvey]="false"
            [courseId]="courseId"
            [trainingTypeId]="trainingType._id"
            (sessionCreated)="(null)"
            (sessionSelected)="setSelectedSurvey($event)"
            [fromRating]="fromRating"
            [ratingType]="ratingType"
            [selectedSurveyID]="selectedSurveryIDTrainers"
          ></app-training-survey>
        </ng-container>
      </p-tabPanel>
    </p-tabView>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      label="{{ 'Submit' | translator }}"
      (onClick)="UpdateRatingSettings()"
    ></p-button>
  </ng-template>
</p-dialog>
<!-- RATTING ADVANCED UI DEVELOPED -->

<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="{{ 'Add Trainer' | translator }}"
  [(visible)]="addTrainerModal"
  [style]="{ margin: '0rem 1rem', width: '70vw' }"
  [maximizable]="true"
>
  <app-add-external-user
    *ngIf="addTrainerModal"
    [addCompany]="true"
    (updatedData)="handleUpdatedUserData($event)"
    [type]="'CREATE'"
    [ExternalType]="'trainer'"
  ></app-add-external-user>
</p-dialog>


<p-dialog
[blockScroll]="true"
  [draggable]="false"
  header="{{ 'Set Reminder' | translator }}"
  [(visible)]="reminderModal"
  [style]="{ width: '95vw', maxWidth: '1700px', maxHeight: '900px' }"
>
<div style=" padding: 15px; background-color: rgba(255, 255, 255, 0.09); border-radius: 15px;">

<app-reminder-modal *ngIf="reminderModal " (close)="reminderModal = false" [_id]="courseData?._id" [startDate]="courseData?.startDate" [type]="'TRAINING'"></app-reminder-modal>
 </div>

</p-dialog>
<!-- ====================End new design here====================== -->
